import { Header, Table } from '@tanstack/react-table';
import { NumberRangeFilter } from 'src/components/Filters/NumberRangeFilter';
import { PosMultiSelect } from 'src/core/POS/PosMultiSelect';
import { TooltipPopover } from 'src/core/ui';
import { ColumnFilterButton } from 'src/core/ui/ColumnFilterButton';
import { useColumnFilter } from 'src/tables/Table/hooks/useColumnFilter';
import { ContentId } from 'src/utils/constants/contentId';

interface ColumnHeaderFilterProps<T extends Record<string, any>> {
  table: Table<T>;
  header: Header<T, unknown>;
}

export const ColumnHeaderFilter = <T extends Record<string, any>>({
  table,
  header,
}: ColumnHeaderFilterProps<T>) => {
  const {
    isColumnFilterActive,
    columnFilterOptionsContent,
    canMultiSelect,
    filterValue,
    setColumnFilterValue,
  } = useColumnFilter(table, header);

  if (!header.column.getCanFilter()) {
    return null;
  }
  // Just for storybook for now. Edit later

  return (
    <>
      {canMultiSelect ? (
        <PosMultiSelect
          values={(filterValue ?? []) as string[]}
          onChange={({ newValues }) => setColumnFilterValue(newValues)}
          onClick={(e) => e.stopPropagation()}
          enableEmptySelection
          valueOptionsContent={columnFilterOptionsContent}
          showSelectedOptionsFirst
          childrenAsTrigger
          placeholderText={ContentId.All}
          searchable={Object.keys(columnFilterOptionsContent).length > 10}
        >
          <ColumnFilterButton isActive={isColumnFilterActive} />
        </PosMultiSelect>
      ) : (
        <TooltipPopover
          triggerContent={
            <ColumnFilterButton isActive={isColumnFilterActive} />
          }
        >
          <NumberRangeFilter
            filterValue={{
              min: (filterValue as [number, number])?.[0],
              max: (filterValue as [number, number])?.[1],
            }}
            setFilterValue={(value) => {
              if (value == null) {
                setColumnFilterValue(undefined);
              }
              setColumnFilterValue([value.min, value.max]);
            }}
          />
        </TooltipPopover>
      )}
    </>
  );
};
